<!-- Main content -->
<section class="content-header">
  <h1 *ngIf="IsReportRoute" i18n="@@Reports">
    Reports
  </h1>
  <h1 *ngIf="!IsReportRoute" i18n="@@Dashboards">
    Dashboards
  </h1>
  <ol class="breadcrumb">
    <li><a><em class="fa fa-dashboard"></em> <span i18n="@@Homepage">Homepage</span></a></li>
    <li class="active" *ngIf="IsReportRoute" i18n="@@Reports">Reports</li>
    <li class="active" *ngIf="!IsReportRoute" i18n="@@Dashboards">Dashboards</li>
  </ol>
</section>
<section class="content">

  <div class="row">
    <div class="col-md-12">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title" *ngIf="IsReportRoute" i18n="@@HomePageBoxReport">My favorite reports</h3>
          <h3 class="box-title" *ngIf="!IsReportRoute" i18n="@@HomePageBoxDashboard">My favorite dashboards</h3>
        </div>
        <!-- /.box-header -->
        <div class="box-body">
          <table class="table table-hover">

            <tbody *ngIf="powerBiObjectsFavorites.length > 0 else loadingFavorite">

              <tr class="raw"  *ngFor="let powerBiObject of powerBiObjectsFavorites" >
                <td  class="col-1">
                    <em class="fa fa-star cursor-pointer" i18n-title="@@RemoveFromMyFavorite"
                      title="Remove from my favorites" (click)="removeFromFavorite(powerBiObject)">
                    </em>
                </td>
                <td class="col cursor-pointer" (click)="goToView(powerBiObject)"  *ngIf="!powerBiObject.customName">{{powerBiObject.name}}</td>
                <td class="col cursor-pointer" (click)="goToView(powerBiObject)"  *ngIf="powerBiObject.customName">{{powerBiObject.customName}}</td>
              <tr>

            </tbody>

          </table>
          <ng-template #loadingFavorite>
            <tbody class="self-centered" >
            <tr>
              <td>
                <span *ngIf="!EmptyResultFavorite"><em class="fa fa-spin fa-refresh"></em>&nbsp;<span i18n="@@InProgress">In progress</span></span>
                <span *ngIf="EmptyResultFavorite" i18n="@@NoResultsFound">No results found</span>
              </td>
            </tr>
            </tbody>
          </ng-template>

        </div>
      </div>
    </div>
  </div>

  <div class="box">
    <div class="box-header with-border">
      <h3 class="box-title" *ngIf="IsReportRoute" i18n="@@MyReports">My reports</h3>
      <h3 class="box-title" *ngIf="!IsReportRoute" i18n="@@MyDashboards">My dashboards</h3>
    </div>
    <div class="box-body">
      <table class="table table-hover">

        <tbody *ngIf="powerBiObjects.length > 0 else loading">
        <tr class="raw" *ngFor="let powerBiObject of powerBiObjects" >
          <td  class="col-1">
            <em class="fa fa-star-o cursor-pointer" i18n-title="@@AddToMyFavorite" title="Add to my favorites" (click)="addToFavoriteReport(powerBiObject)"></em>
        </td>
          <td class="col cursor-pointer" (click)="goToView(powerBiObject)" (KeyPress)="goToView(powerBiObject)" *ngIf="!powerBiObject.customName">{{powerBiObject.name}}</td>
          <td class="col cursor-pointer"  (click)="goToView(powerBiObject)" (KeyPress)="goToView(powerBiObject)"  *ngIf="powerBiObject.customName">{{powerBiObject.customName}}</td>
        <tr>
        </tbody>

      </table>

      <ng-template #loading>
        <tbody class="self-centered" >
        <tr>
          <td>
            <span *ngIf="!EmptyResult"><em class="fa fa-spin fa-refresh"></em>&nbsp;<span i18n="@@InProgress">In progress</span></span>
            <span *ngIf="EmptyResult" i18n="@@NoResultsFound">No results found</span>
          </td>
        </tr>
        </tbody>
      </ng-template>

    </div>
  </div>
</section>
